import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import type { RBACUser } from '../../../types';
import { intuneUserUrl } from '../../graph/intune';

type UserInfoProps = {
  user: RBACUser | undefined;
};

const NA = <span className="opacity-60">N/A</span>;

export default function UserInfo({ user }: UserInfoProps) {
  if (!user) {
    return <div></div>;
  }

  // Fixed 2-column, 3-row layout: a two-column grid holding two label/value sub-grids.
  // Identity fields on the left, location/status/portal on the right. Each sub-grid keeps
  // its labels aligned, and the fixed grid-cols-2 stays 2×3 rather than collapsing tall.
  return (
    <div className="grid grid-cols-2 gap-x-16 text-sm">
      <div className="grid grid-cols-[auto_minmax(0,1fr)] content-start gap-x-3 gap-y-1">
        <span className="font-bold">Name:</span>
        <span className="truncate" title={user.displayName}>
          {user.displayName}
        </span>
        <span className="font-bold">UPN:</span>
        <span className="truncate" title={user.userPrincipalName}>
          {user.userPrincipalName}
        </span>
        <span className="font-bold">Job Title:</span>
        <span className="truncate">{user.jobTitle || NA}</span>
      </div>
      <div className="grid grid-cols-[auto_minmax(0,1fr)] content-start gap-x-3 gap-y-1">
        <span className="font-bold">Location:</span>
        <span className="truncate">{user.officeLocation || NA}</span>
        <span className="font-bold">Account Status:</span>
        <span className={user.accountEnabled ? 'text-success' : 'text-error'}>
          {user.accountEnabled ? 'Enabled' : 'Disabled'}
        </span>
        <span className="font-bold">Portal:</span>
        <span>
          <a
            className="link link-primary inline-flex items-center gap-1"
            href={intuneUserUrl(user.id)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Intune
            <ArrowTopRightOnSquareIcon className="h-4 w-4 shrink-0" />
          </a>
        </span>
      </div>
    </div>
  );
}
